<script lang='ts'>
    import { _ } from 'svelte-i18n'
    import { ForecastType, SpecificityTypes, FocusTypes } from './constants';
    import type { SelectedMode, ForecastActivityState } from './constants';
    import { getForecastResultsForChart, getIntervalAdvice, round } from '@/Util/utils';
    import Skeleton from '@/lib/components/ui/skeleton/skeleton.svelte';
  import type { MedianAndWeatherStores, MyFitnessStores } from '@/MyFitness/stores';
  import { getContext } from 'svelte';
  import { fade, slide } from 'svelte/transition';

    export let forecastInfo: ForecastActivityState
    export let selectedMode: SelectedMode
    export let myFitness: MyFitnessStores

    const { trainingMedians } = getContext<MedianAndWeatherStores>('medianAndWeather')
    let { trainingPlan, cal_settings } = myFitness

    //@ts-ignore
    const Xert = window.Xert

    $: isCyclingProfile = Xert._sport_type == "Cycling"

    // let zoneInfo: string | null = null
    // let minutePower: number | null = null
    // $: {
    //     if (forecastInfo.type == ForecastType.HighIntensity) {
    //         minutePower = forecastInfo.minutePower
    //     } else minutePower = round(forecastInfo.signature.ltp, 1)

    //     switch (forecastInfo.focus) {
    //         case FocusTypes.RoadSprinter:
    //             zoneInfo = $_('forecast_descriptions.road_sprinter.zone_info')
    //             break
    //         case FocusTypes.Pursuiter:
    //             zoneInfo = $_('forecast_descriptions.pursuiter.zone_info')
    //             break
    //         case FocusTypes.Puncheur:
    //             zoneInfo = $_('forecast_descriptions.puncheur.zone_info')
    //             break
    //         case FocusTypes.BreakawaySpecialist:
    //             zoneInfo = $_('forecast_descriptions.breakaway_specialist.zone_info')
    //             break
    //         case FocusTypes.Rouleur:
    //             zoneInfo = $_('forecast_descriptions.rouleur.zone_info')
    //             break
    //         case FocusTypes.GcSpecialist:
    //             zoneInfo = $_('forecast_descriptions.gc_specialist.zone_info')
    //             break
    //         case FocusTypes.Climber:
    //             zoneInfo = $_('forecast_descriptions.climber.zone_info')
    //             break
    //         case FocusTypes.Endurance:
    //             if (forecastInfo.type == ForecastType.HighIntensity) zoneInfo = $_('forecast_descriptions.endurance.high_intensity.zone_info')
    //             else zoneInfo = $_('forecast_descriptions.endurance.low_intensity.zone_info')
    //             break
    //         default:
    //             zoneInfo = null
    //             console.error("Unknown focus type: " + forecastInfo.focus)
    //             break
    //     }
    // }
    
    let warningVisible = false
    $: intervalInfoPromise = getIntervalAdvice(forecastInfo.type, forecastInfo.duration, forecastInfo.activitySignature, forecastInfo.targets)
    $: forecastChartResultsPromise = getForecastResultsForChart($trainingPlan.forecastResults, $trainingPlan.settings, $cal_settings, $trainingMedians)

</script>

<!--
    NOTE: I only found this out after finishing most of the work, but svelte-i18n's type declaration for _ is incorrect.
    it says it can only return string, but in reality it can return an object if you don't query a leaf node.
    I don't know if we should make use of that or not, it would make the file much shorter and more readable,
    but it is undocumented behavior and might be removed in the future.
-->

{#await forecastChartResultsPromise}
    <div out:slide on:introstart={() => {warningVisible = false}} on:outroend={() => {warningVisible = true}}>
        <Skeleton class="h-11 w-full mb-3" />
    </div>
{:then forecastChartResults}
    {@const notes = forecastChartResults?.forecastResults?.days?.find(day=>day.path == forecastInfo.path)?.notes}
    {#if notes && warningVisible}
        <div class="flex gap-3 mb-3 border border-border rounded overflow-clip pr-4 py-2" in:slide>
            <div class="w-1.5 -my-2 bg-[#ff00ff]"/>
            <div class="flex flex-col space-y-1.5">
                <div class="font-medium text-sm">Warnings</div>
                <div class="flex flex-col gap-1">
                    {#each notes?.split(', ') as note}
                        <div>{#if note} {$_('forecast.constraints.'+note)} {/if}</div>
                    {/each}
                </div>
            </div>
        </div>
    {/if}
{/await}

{#if forecastInfo.type == ForecastType.Rest}
    {$_('forecast_descriptions.rest.main')}
    {#if forecastInfo.weeksToEvent < 2 && selectedMode != "target_focus"}
        {$_('forecast_descriptions.rest.last_2_weeks')}
    {:else}
        {$_('forecast_descriptions.rest.many_weeks')}
    {/if}
    <br />
{:else if forecastInfo.type == ForecastType.Recovery}
    {$_('forecast_descriptions.recovery')}
    <br />
{:else if forecastInfo.type == ForecastType.LowIntensity}
    {$_('forecast_descriptions.low_intensity.main')}
    <br />
{/if}



{#if forecastInfo.weeksToEvent == 1  && selectedMode != "target_focus"}
    {$_('forecast_descriptions.2nd_last_week')}
    <br />
{:else if forecastInfo.weeksToEvent == 0 && selectedMode != "target_focus"}
    {$_('forecast_descriptions.last_week')}
    <br />
{/if}



{#if forecastInfo.type == ForecastType.LowIntensity}
    {#if forecastInfo.daysToHighIntensity >= forecastInfo.polarizationLevel}
        {$_('forecast_descriptions.low_intensity.no_taper_next_high_far', {values: {polarizationLevel: forecastInfo.polarizationLevel}})}
    {:else}
        {$_('forecast_descriptions.low_intensity.no_taper_next_high_close', {values: {LTP: round(forecastInfo.currentSignature.ltp, 1), daysToHI: forecastInfo.daysToHighIntensity}})}
    {/if}
    <br />
{/if}



{#if forecastInfo.focus == FocusTypes.RoadSprinter}
    {$_('forecast_descriptions.road_sprinter.main')}
    {#if isCyclingProfile}
        {$_('forecast_descriptions.road_sprinter.cycling')}
    {/if}
    <br />
{:else if forecastInfo.focus == FocusTypes.Pursuiter}
    {$_('forecast_descriptions.pursuiter.main')}
    {#if isCyclingProfile}
        {$_('forecast_descriptions.pursuiter.cycling')}
    {/if}
    <br />
{:else if forecastInfo.focus == FocusTypes.Puncheur}
    {$_('forecast_descriptions.puncheur.main')}
    {#if isCyclingProfile}
        {$_('forecast_descriptions.puncheur.cycling')}
    {/if}
    <br />
{:else if forecastInfo.focus == FocusTypes.BreakawaySpecialist}
    {$_('forecast_descriptions.breakaway_specialist.main')}
    {#if isCyclingProfile}
        {$_('forecast_descriptions.breakaway_specialist.cycling')}
    {/if}
    <br />
{:else if forecastInfo.focus == FocusTypes.Rouleur}
    {$_('forecast_descriptions.rouleur.main')}
    {#if isCyclingProfile}
        {$_('forecast_descriptions.rouleur.cycling')}
    {/if}
    <br />
{:else if forecastInfo.focus == FocusTypes.GcSpecialist}
    {$_('forecast_descriptions.gc_specialist.main')}
    {#if isCyclingProfile}
        {$_('forecast_descriptions.gc_specialist.cycling')}
    {/if}
    <br />
{:else if forecastInfo.focus == FocusTypes.Climber}
    {$_('forecast_descriptions.climber.main')}
    {#if isCyclingProfile}
        {$_('forecast_descriptions.climber.cycling')}
    {/if}
    <br />
{:else if forecastInfo.focus == FocusTypes.Endurance }
    {#if forecastInfo.type == ForecastType.LowIntensity}
        {$_('forecast_descriptions.endurance.low_intensity.main')}
        <br />
    {:else if forecastInfo.type == ForecastType.HighIntensity}
        {$_('forecast_descriptions.endurance.high_intensity.main')}
        <br />
    {/if}
{/if}

{#if forecastInfo.specificity == SpecificityTypes.Pure && forecastInfo.focus != FocusTypes.Endurance}
    {$_('forecast_descriptions.pure')}
{:else if forecastInfo.specificity == SpecificityTypes.Mixed}
    {$_('forecast_descriptions.mixed', {values: {LTP: round(forecastInfo.currentSignature.ltp, 1)}})}
{:else if forecastInfo.specificity == SpecificityTypes.Polar}
    {$_('forecast_descriptions.polar', {values: {LTP: round(forecastInfo.currentSignature.ltp, 1)}})}
{/if}
<br />

{#if forecastInfo.type == ForecastType.HighIntensity}
    {#if forecastInfo.isChallenging}
        {$_('forecast_descriptions.high_intensity.challenging')}
    {:else}
        {$_('forecast_descriptions.high_intensity.not_challenging')}
    {/if}
    <br />

    {#if forecastInfo.nextDayType == ForecastType.Recovery}
        {$_('forecast_descriptions.high_intensity.tmrw_recovery')}
        <br />
    {/if}
{/if}

{#if forecastInfo.type == ForecastType.LowIntensity && forecastInfo.nextDayType == ForecastType.Recovery}
    {$_('forecast_descriptions.low_intensity.tmrw_recovery')}
    <br />
{:else if (forecastInfo.type != ForecastType.Recovery && ((forecastInfo.nextDayType == ForecastType.Rest && forecastInfo.weeksToEvent >= 2) || selectedMode == "target_focus"))}
    {$_('forecast_descriptions.tmrw_rest_no_taper')}
    <br />
{/if}

<!-- {#if zoneInfo && minutePower}
    Zone: {zoneInfo} Target Interval Power: {minutePower} watts.
{/if} -->

<!-- {#await intervalInfoPromise}
    <Skeleton class="h-4 w-full" />
{:then intervalInfo}
    {#if intervalInfo?.duration}
        Interval Power: {intervalInfo.power} Watts, Interval Duration: {intervalInfo.duration} Seconds, Recovery Power: {intervalInfo.recoveryPower} Watts
    {:else}
        Endurance Power: {intervalInfo.power} Watts
    {/if}
{/await} -->

<style lang='scss'>
    br {
        display: block;
        margin: 12px 0 0;
        line-height:22px;
        content: " ";
    }
</style>
